
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'CatalogFilterSortBar',
  props: {
    active: {
      type: String,
      default: '',
    },
  },
  emits: ['toggle'],
})
